import { api, ENDPOINTS } from '../config';
import { EventLogFilters, EventLogResponse, EventLogResponseData } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getEventLog(filters?: EventLogFilters): Promise<EventLogResponseData> {
  const response = await api.get<EventLogResponse>(ENDPOINTS.EVENTLOG, {
    params: filters,
  });
  
  return response;
}